export const addAppsflyer = () => {
  const fsc = document.createElement('script')
  fsc.text = '!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","pba",{pba: {webAppId: "fc4cdb2a-8701-4a8f-8e10-25157b5d2418", measurementStatus: true}})'
  document.body.appendChild(fsc)
}
export const addWavveLoggerLib = () => {
  const dc = document.getElementsByTagName('script')[0]
  if (!dc) { console.warn('no script tag'); return }
  const asl = document.createElement('script')
  asl.async = true
  asl.src = 'https://www.wavve.com/js/wavve.logger.js'
  dc.parentNode.insertBefore(asl, dc)
}
